(() => {
  const proofMarkup = `
    <div class="dtcc-cart-proof" data-dtcc-cart-proof>
      <div class="dtcc-proof-row"><span class="dtcc-proof-label">COFFEE SHIPPING</span><strong class="dtcc-proof-answer">FREE</strong></div>
      <div class="dtcc-proof-row"><span class="dtcc-proof-label">MERCH SHIPPING</span><strong class="dtcc-proof-answer">CALCULATED AT CHECKOUT</strong></div>
      <div class="dtcc-proof-row"><span class="dtcc-proof-label">COFFEE + MERCH</span><strong class="dtcc-proof-answer">SHIPS SEPARATELY</strong></div>
      <p class="dtcc-proof-note">Different products. Different boxes. Same order. No surprises at checkout.</p>
    </div>`;

  function enhanceCart() {
    document.querySelectorAll('cart-drawer').forEach((drawer) => {
      const footer = drawer.querySelector('.drawer__footer');
      if (footer && !drawer.querySelector('[data-dtcc-cart-proof]')) {
        footer.insertAdjacentHTML('afterbegin', proofMarkup);
      }

      const empty = drawer.querySelector('.cart-drawer__empty-content');
      const heading = empty && empty.querySelector('h2, .cart__empty-text');
      if (heading) heading.textContent = 'YOUR CART IS DECEASED.';
    });
  }

  let queued = false;
  const queueEnhance = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhanceCart();
    });
  };

  document.addEventListener('DOMContentLoaded', enhanceCart);
  new MutationObserver(queueEnhance).observe(document.documentElement, { childList: true, subtree: true });
})();
